import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Form,
  Row,
  Col,
  Button,
  Table,
  Divider,
  message,
  DatePicker,
  Select,
} from "antd";
import NProgress from "nprogress";
import { fetchOrderDetail } from "../../../api/takeOut";

const { Column } = Table;
const BreadCrumbData = [
  { path: "/page/dataanalysis/dataanalysis", name: "数据分析" },
  { path: "/page/dataanalysis/takeOutOrderRecord", name: "外卖订单记录" },
  { path: "", name: "查看详情" },
];

class TakeOutOrderRecordDetail extends React.Component {
  state = {
    orderId: this.props.match.params.id,
    takeInfo: {},
    buyInfo: [
      // {
      //   capsuleNo: "100",
      //   refund: true,
      //   totalPrice: 3.0,
      //   materials: [
      //     {
      //       materialsName: "雪碧",
      //       pic:
      //         "https://qiniu-retail.ieou.com/8810f44d-b6f5-46e8-9d8e-e8520c14751c.png",
      //       barCode: "5453",
      //       price: 3.0,
      //       quantity: "1",
      //       total: 3.0,
      //       result: "SUCCESS",
      //       refund: false,
      //       refundTime: null,
      //       capsuleNo: "100",
      //     },
      //   ],
      // },
      // {
      //   capsuleNo: "100",
      //   refund: true,
      //   totalPrice: 3.0,
      //   materials: [
      //     {
      //       materialsName: "雪碧",
      //       pic:
      //         "https://qiniu-retail.ieou.com/8810f44d-b6f5-46e8-9d8e-e8520c14751c.png",
      //       barCode: "5453",
      //       price: 3.0,
      //       quantity: "1",
      //       total: 3.0,
      //       result: "SUCCESS",
      //       refund: false,
      //       refundTime: null,
      //       capsuleNo: "100",
      //     },
      //   ],
      // },
    ],
    orderInfo: {},
  };
  async componentDidMount() {
    NProgress.start();
    await this.fetchOrderDetail();
    NProgress.done();
  }
  fetchOrderDetail = () => {
    fetchOrderDetail(this.state.orderId).then((res) => {
      if (res.success) {
        this.setState({
          takeInfo: res.data.takeInfo,
          buyInfo: res.data.buyInfo,
          orderInfo: res.data.orderInfo,
        });
      } else {
        message.error(res.message);
      }
    });
  };
  render0 = (refundStatus) => {
    switch (refundStatus) {
      case 1:
        return <span>待确认</span>;
        break;
      case 5:
        return <span>已确认</span>;
        break;
      case 7:
        return <span>骑士已接单</span>;
        break;
      case 8:
        return <span>骑士已取餐</span>;
        break;
      case 9:
        return <span>已完成</span>;
        break;
      case 10:
        return <span>已取消</span>;
        break;
      case 15:
        return <span>订单退款</span>;
        break;
    }
  };

  renderGoodsList = (refund) => {
    const {
      buyInfo: {
        address,
        capsuleNo,
        discountFee,
        name,
        privacyPhone,
        sendFee,
        shopFee,
        totalFee,
        userFee,
        goodsList,
      },
    } = this.state;
    return (
      <React.Fragment>
        <div className="detailOptions">
          <div style={{ flex: 1 }}>客户名称：{name}</div>
          <div style={{ flex: 1 }}>客户电话：{privacyPhone}</div>
          <div style={{ flex: 2 }}>客户地址：{address}</div>
        </div>
        <div style={{ height: 34, lineHeight: "34px" }}>
          设备编号：{capsuleNo}
        </div>
        <Table
          style={{ margin: "10px 0" }}
          dataSource={goodsList}
          pagination={false}
          footer={() => (
            <div style={{ textAlign: "right", paddingRight: 20 }}>
              <span style={{ paddingRight: 50 }}>
                {" "}
                配送费：￥{sendFee / 100}
              </span>
              <span style={{ paddingRight: 50 }}>
                {" "}
                优惠金额：￥{discountFee / 100}
              </span>
              <span style={{ paddingRight: 50 }}>
                {" "}
                订单总金额：￥{totalFee / 100}
              </span>
              <span style={{ paddingRight: 50 }}>
                {" "}
                客户实付金额：￥{userFee / 100}
              </span>
              <span> 商户应收金额：￥{shopFee / 100}</span>
            </div>
          )}
          rowKey={(value, index) => index}
        >
          <Column
            title="商品名称"
            dataIndex="materialsName"
            key="materialsName"
          />
          <Column
            title="商品图片"
            dataIndex="pic"
            key="pic"
            render={(value) =>
              value ? (
                <img style={{ width: 40, height: 40 }} src={value}></img>
              ) : null
            }
          />
          <Column title="商品编码" dataIndex="customSkuId" key="customSkuId" />
          <Column title="商品单价" dataIndex="price" key="price" />
          <Column title="货道号" dataIndex="aisleNo" key="aisleNo" />
          {/* <Column title="商品总价" dataIndex="total" key="total" /> */}
          <Column
            title="出货状态"
            dataIndex="result"
            key="result"
            render={(value) =>
              value == "出货失败，已退款" ? (
                <span style={{ color: "#FC9600" }}>出货失败，已退款</span>
              ) : (
                value
              )
            }
          />
        </Table>
      </React.Fragment>
    );
    // return buyInfo.map((item, index) => {
    //   if (!refund && !item.refund) {
    //     return (
    //       <React.Fragment key={index}>
    //         <div style={{ height: 32, lineHeight: "32px" }}>
    //           设备编号：{item.capsuleNo}
    //         </div>
    //         <Table
    //           style={{ margin: "10px 0" }}
    //           dataSource={item.materials}
    //           pagination={false}
    //           footer={() => (
    //             <div style={{ textAlign: "right", paddingRight: 20 }}>
    //               合计：￥{item.totalPrice}
    //             </div>
    //           )}
    //           rowKey={(value, index) => index}
    //         >
    //           <Column
    //             title="商品名称"
    //             dataIndex="materialsName"
    //             key="materialsName"
    //           />
    //           <Column
    //             title="商品图片"
    //             dataIndex="pic"
    //             key="pic"
    //             render={(value) =>
    //               value ? (
    //                 <img style={{ width: 40, height: 40 }} src={value}></img>
    //               ) : null
    //             }
    //           />
    //           <Column title="条形码" dataIndex="barCode" key="barCode" />
    //           <Column title="单价/元" dataIndex="price" key="price" />
    //           <Column title="数量" dataIndex="quantity" key="quantity" />
    //           <Column title="总价/元" dataIndex="total" key="total" />
    //         </Table>
    //       </React.Fragment>
    //     );
    //   } else if (refund && item.refund) {
    //     return (
    //       <React.Fragment key={index}>
    //         <div style={{ height: 32, lineHeight: "32px" }}>
    //           设备编号：{item.capsuleNo}
    //         </div>
    //         <Table
    //           style={{ margin: "10px 0" }}
    //           dataSource={item.materials}
    //           pagination={false}
    //           footer={() => (
    //             <div style={{ textAlign: "right", paddingRight: 20 }}>
    //               合计：￥{item.totalPrice}
    //             </div>
    //           )}
    //           rowKey={(value, index) => index}
    //         >
    //           <Column
    //             title="商品名称"
    //             dataIndex="materialsName"
    //             key="materialsName"
    //           />
    //           <Column
    //             title="商品图片"
    //             dataIndex="pic"
    //             key="pic"
    //             render={(value) =>
    //               value ? (
    //                 <img style={{ width: 40, height: 40 }} src={value}></img>
    //               ) : null
    //             }
    //           />
    //           <Column title="条形码" dataIndex="barCode" key="barCode" />
    //           <Column title="单价/元" dataIndex="price" key="price" />
    //           <Column title="数量" dataIndex="quantity" key="quantity" />
    //           <Column title="总价/元" dataIndex="total" key="total" />
    //           <Column
    //             title="退款时间"
    //             dataIndex="refundTime"
    //             key="refundTime"
    //           />
    //           <Column
    //             title="退款状态"
    //             dataIndex="refund"
    //             key="refund"
    //             render={(value) => (value ? "退款成功" : "退款失败")}
    //           />
    //         </Table>
    //       </React.Fragment>
    // );
    // }
    // });
  };
  render() {
    const {
      takeInfo: {
        capsuleNo,
        atshopTime,
        confirmTime,
        deliveryTime,
        pickUpNumber,
        shipmentStartTime,
        shipmentOverTime,
      },
      orderInfo: {
        createTime,
        finishedTime,
        orderId,
        status,
        totalFee,
        cancelTime,
      },
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>

        <div style={{ padding: "16px 24px" }}>
          {" "}
          <Button onClick={() => this.props.history.go(-1)}>返回</Button>
        </div>
        <div className="content">
          <div className="detailTitle">订单信息</div>
          <div
            style={{
              borderBottom: "1px solid  rgba(232, 232, 232, 1)",
              margin: "10px 0",
            }}
          ></div>
          <div className="detailOptions">
            <div style={{ flex: 1 }}>创建时间：{createTime}</div>
            <div style={{ flex: 1 }}>订单编号：{orderId}</div>
            <div style={{ flex: 1 }}>
              订单金额：
              {totalFee / 100}
            </div>
            <div style={{ flex: 1 }}>订单状态：{this.render0(status)}</div>
          </div>
          {cancelTime ? (
            <div className="detailOptions">
              <div style={{ flex: 1 }}>取消时间：{cancelTime}</div>
              <div style={{ flex: 1 }}></div>
              <div style={{ flex: 1 }}></div>
            </div>
          ) : (
            <React.Fragment>
              <div className="detailOptions">
                <div style={{ flex: 1 }}>完成时间：{finishedTime}</div>
                <div style={{ flex: 1 }}>
                  {/* &nbsp;&nbsp;&nbsp;&nbsp;取餐号：{pickUpNumber} */}
                </div>
                <div style={{ flex: 1 }}></div>
                <div style={{ flex: 1 }}></div>
              </div>
              {/* <div className="detailOptions">
                <div style={{ flex: 1 }}>完成时间：{overTime}</div>
                <div style={{ flex: 1 }}></div>
                <div style={{ flex: 1 }}></div>
              </div> */}
            </React.Fragment>
          )}

          {/* <div
            style={{
              borderBottom: "1px solid  rgba(232, 232, 232, 1)",
              margin: "10px 0",
            }}
          ></div>

          <div className="detailTitle">客户信息</div>
          <div className="detailOptions">
            <div style={{ flex: 1 }}>客户姓名：{consignee}</div>
            <div style={{ flex: 1 }}>联系电话：{phoneList}</div>
            <div style={{ flex: 1 }}>备注：{description}</div>
          </div>
          <div style={{ height: 32, lineHeight: "32px" }}>
            客户地址：{deliveryPoiAddress}
          </div>
          <div className="lineBetween"></div>
          {buyInfo.filter((item) => !item.refund).length >= 1 ? (
            <React.Fragment>
              <div className="detailTitle">商品列表</div>
              {this.renderGoodsList(false)}
            </React.Fragment>
          ) : null} */}
        </div>
        <div style={{ marginTop: 10 }} className="content">
          <div className="detailTitle">购买信息</div>
          <div
            style={{
              borderBottom: "1px solid  rgba(232, 232, 232, 1)",
              margin: "10px 0",
            }}
          ></div>
          {this.renderGoodsList()}
        </div>
        {status ? (
          status == 10 ? null : (
            <div style={{ marginTop: 10 }} className="content">
              <div className="detailTitle">取货信息</div>
              <div
                style={{
                  borderBottom: "1px solid  rgba(232, 232, 232, 1)",
                  margin: "10px 0",
                }}
              ></div>
              <div className="detailOptions">
                <div style={{ flex: 1 }}>取货设备：{capsuleNo}</div>
                <div style={{ flex: 3 }}>取货号码：{pickUpNumber}</div>
              </div>
              <div className="detailOptions">
                <div style={{ flex: 1 }}>到店时间：{atshopTime}</div>
                <div style={{ flex: 1 }}>取货开始时间：{shipmentStartTime}</div>
                <div style={{ flex: 1 }}>取货完成时间：{shipmentOverTime}</div>
                <div style={{ flex: 1 }}>送货时间：{deliveryTime}</div>
              </div>
              <div className="detailOptions">
                <div style={{ flex: 1 }}>商家确认订单时间：{confirmTime}</div>
              </div>
            </div>
          )
        ) : null}

        {/* {buyInfo.filter((item) => item.refund).length >= 1 ? (
          <div style={{ marginTop: 10 }} className="content">
            <div className="detailTitle">退单商品</div>
            {this.renderGoodsList(true)}
          </div>
        ) : null} */}
      </div>
    );
  }
}
export default TakeOutOrderRecordDetail;
